import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import pt from 'prop-types';

import { BlockOverlay } from 'components/storefront/editor/easyblocks-page/components/overlay';
import {
  removeSwellPagePrefix,
  getParentFocusedField,
} from 'components/storefront/editor/utils/easyblocks';

function Block(props) {
  const {
    __easyblocks: easyblocks,
    blockData,
    blockConfigs,
    element,
    sectionSelected,
    sectionHovered,
    overlayRootRef,
  } = props;
  const { path } = easyblocks;

  const selected = path === getParentFocusedField();
  const normalizedPath = useMemo(() => removeSwellPagePrefix(path), [path]);

  return createPortal(
    <BlockOverlay
      path={normalizedPath}
      selected={selected}
      sectionSelected={sectionSelected}
      sectionHovered={sectionHovered}
      blockData={blockData}
      blockConfigs={blockConfigs}
      element={element}
    />,
    overlayRootRef.current,
  );
}

Block.propTypes = {
  __easyblocks: pt.object,
  blockData: pt.object,
  blockConfigs: pt.object,
  element: pt.instanceOf(HTMLElement),
  sectionSelected: pt.bool,
  sectionHovered: pt.bool,
  sectionOverlayRef: pt.object,
};

function getBlockComponent(theme) {
  function BlockWrapper(blockProps) {
    return <Block theme={theme} {...blockProps} />;
  }

  return React.memo(BlockWrapper);
}

export default getBlockComponent;
